export default "<div>\n  <img src=\"../../../../../../assets/images/icons/verify.svg\"/>\n</div>\n"